import { PlatformStatusBadge } from "@replicate/ui";
import { useQuery } from "@tanstack/react-query";

interface StatuspageSummary {
  components: { id: string; status: string }[];
}

// NOTE: the Replicate component id on cloudflarestatus.com
const REPLICATE_COMPONENT_ID = "fvgfcmy66tdr";

function useReplicateStatus() {
  return useQuery({
    queryKey: ["replicateStatus"],
    queryFn: async () => {
      const res = await fetch(
        "https://www.cloudflarestatus.com/api/v2/summary.json"
      );
      if (!res.ok) {
        throw new Error("Failed to fetch incident status");
      }

      const json = (await res.json()) as StatuspageSummary;
      const component = json.components.find(
        (c) => c.id === REPLICATE_COMPONENT_ID
      );
      // NOTE: hide the badge rather than misreport if the component id ever
      // disappears from the summary (e.g. a Cloudflare-side restructure).
      if (!component) {
        throw new Error("Replicate component not found in status summary");
      }

      return component.status === "operational" ? "healthy" : "degraded";
    },
  });
}

export default function PlatformStatus() {
  const { status, data } = useReplicateStatus();

  if (status === "pending" || status === "error") {
    return null;
  }

  return (
    <div className="platform-status">
      <PlatformStatusBadge
        url="https://www.cloudflarestatus.com/services?search=replicate"
        status={data}
      />
    </div>
  );
}
